const state = () => ({
  isShowRuneFilter: false,
  selectedRuneIdList: [], // 선택한 runeId 목록

  isShowItemCategoryFilter: false,
  selectedItemCategoryNameList: [], // 선택한 itemCategory 목록

  isShowSocketCountFilter: false,
  selectedSocketCountList: [],

  isShowRecommandFilter: false,
  selectedRecommandList: [], // 추천 아이템 항목

  searchKeyword: "",
});

const getters = {
  isSelectedRuneId: (state) => (runeId) => {
    return state.selectedRuneIdList.indexOf(runeId) >= 0;
  },
  isSelectedItemCategoryName: (state) => (itemCategoryName) => {
    return state.selectedItemCategoryNameList.indexOf(itemCategoryName) >= 0;
  },
};

const mutations = {
  toggleIsShowRuneFilter(state) {
    state.isShowRuneFilter = !state.isShowRuneFilter;
  },
  // selectedRuneIdList에 runeId를 추가하거나 삭제
  toggleSelectedRuneId(state, runeId) {
    if (this.getters["diablo2/runewordSearch/isSelectedRuneId"](runeId)) {
      state.selectedRuneIdList.splice(
        state.selectedRuneIdList.indexOf(runeId),
        1
      );
    } else {
      state.selectedRuneIdList.push(runeId);
    }
  },
  clearSelectedRuneIdList(state) {
    state.selectedRuneIdList.splice(0, state.selectedRuneIdList.length);
  },

  toggleIsShowItemCategoryFilter(state) {
    state.isShowItemCategoryFilter = !state.isShowItemCategoryFilter;
  },
  toggleSelectedItemCategoryName(state, itemCategoryName) {
    if (
      this.getters["diablo2/runewordSearch/isSelectedItemCategoryName"](
        itemCategoryName
      )
    ) {
      state.selectedItemCategoryNameList.splice(
        state.selectedItemCategoryNameList.indexOf(itemCategoryName),
        1
      );
    } else {
      state.selectedItemCategoryNameList.push(itemCategoryName);
    }
  },
  clearSelectedItemCategoryNameList(state) {
    state.selectedItemCategoryNameList.splice(
      0,
      state.selectedItemCategoryNameList.length
    );
  },

  toggleIsShowSocketCountFilter(state) {
    state.isShowSocketCountFilter = !state.isShowSocketCountFilter;
  },
  toggleSelectedSocketCountList(state, ele) {
    var targetValue = ele.target.value;
    if (state.selectedSocketCountList.indexOf(targetValue) >= 0) {
      state.selectedSocketCountList.splice(
        state.selectedSocketCountList.indexOf(targetValue),
        1
      );
    } else {
      state.selectedSocketCountList.push(targetValue);
    }
  },
  clearSelectedSocketCountList(state) {
    state.selectedSocketCountList.splice(
      0,
      state.selectedSocketCountList.length
    );
  },

  toggleIsShowRecommandFilter(state) {
    state.isShowRecommandFilter = !state.isShowRecommandFilter;
  },
  toggleSelectedRecommandList(state, ele) {
    var targetValue = ele.target.value;
    if (state.selectedRecommandList.indexOf(targetValue) >= 0) {
      state.selectedRecommandList.splice(
        state.selectedRecommandList.indexOf(targetValue),
        1
      );
    } else {
      this.commit("diablo2/runewordSearch/clearSelectedRecommandList");
      state.selectedRecommandList.push(targetValue);
    }
  },
  clearSelectedRecommandList(state) {
    state.selectedRecommandList.splice(0, state.selectedRecommandList.length);
  },

  changeSearchKeyword(state, ele) {
    state.searchKeyword = ele.target.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {},
  modules: {},
};
